import React, { useState } from 'react';
import { Tab } from 'common/components';
import { useAuth } from 'contexts/AuthContext';
import { UserRole } from 'types/userRoles';
// import { AgentMonitoringTab } from './components';
import { PerformanceAnalyticsTab, WorkflowAssignmentsTab } from './components';
import styles from './ManagerCommandCenter.module.scss';

type ActiveTab = 'monitoring' | 'assignments' | 'performance';

const ManagerCommandCenter: React.FC = () => {
    const { userRoles } = useAuth();

    const isManager = userRoles.some(
        (role) => role === UserRole.MANAGER || role === UserRole.SUPER_ADMIN || role === UserRole.ADMIN
    );

    const [activeTab, setActiveTab] = useState<ActiveTab>('performance');

    const tabs = [
        ...(isManager
            ? [
                  { id: 'performance', label: 'Performance analytics' },
                  { id: 'assignments', label: 'Workflow Assignments' },
              ]
            : []),
        // { id: 'monitoring', label: 'Agent Monitoring' },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>Manager Command Center</h1>
            </div>

            <Tab
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={(id) => setActiveTab(id as ActiveTab)}
                className={styles.tabs}
            />

            <div className={styles.contentArea}>
                {activeTab === 'performance' && <PerformanceAnalyticsTab isManager={isManager} />}
                {activeTab === 'assignments' && isManager && <WorkflowAssignmentsTab />}
                {/* {activeTab === 'monitoring' && <AgentMonitoringTab isManager={isManager} />} */}
            </div>
        </div>
    );
};

export default ManagerCommandCenter;
